import { Injectable } from '@angular/core';
import { AppConfig } from '../../app.config';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MarketplaceCategoryService {
  constructor(private http: HttpClient, private api: AppConfig) { }

  addMarketplaceCategory (data) {
    return this.http.post(this.api.baseUrl + '/marketplaceCategory/addMarketplaceCategory' , data , this.api.jsonTokenHeaders);
  }

  getMarketplaceCategory (search= '') {
    return this.http.get(this.api.baseUrl + '/marketplaceCategory/getMarketplaceCategory?search=' + search, this.api.jsonTokenHeaders);
  }

  deleteMarketplaceCategory (id) {
    return this.http.get(this.api.baseUrl + '/marketplaceCategory/deleteMarketplaceCategory?id=' + id, this.api.jsonTokenHeaders);
  }

  addMarketplaceSubCategory (data) {
    return this.http.post(this.api.baseUrl + '/marketplaceSubCategory/addMarketplaceSubCategory' , data , this.api.jsonTokenHeaders);
  }

  getMarketplaceSubCategory () {
    return this.http.get(this.api.baseUrl + '/marketplaceSubCategory/getMarketplaceSubCategory', this.api.jsonTokenHeaders);
  }

  deleteMarketplaceSubCategory (id) {
    return this.http.get(this.api.baseUrl + '/marketplaceSubCategory/deleteMarketplaceSubCategory?id=' + id, this.api.jsonTokenHeaders);
  }

  getUsersForMarketplaceCategory (type, countryId, cityId, organizationId) {
    return this.http.get(this.api.baseUrl + '/marketplaceCategory/marketplaceUser?type=' + type +
      '&countryId=' + countryId + '&cityId' + cityId + '&organizationId' + organizationId, this.api.jsonTokenHeaders);
  }
}
